import React from 'react';

export const normalizeNewlines = (text) =>
  String(text)
    .replace(/\\r\\n|\\n|\\r/g, '\n') // literal escaped sequences
    .replace(/\r\n|\r|\u2028|\u2029/g, '\n'); // real line-break characters

export const renderMultiline = (text) => {
  if (text === null || text === undefined) return null;
  if (typeof text !== 'string') return text;

  const lines = normalizeNewlines(text).split('\n');

  return lines.map((line, i) => {
    const isLast = i === lines.length - 1;
    const needsExtraBr = isLast && line === '' && i > 0;

    return (
      <React.Fragment key={i}>
        {line}
        {!isLast && <br />}
        {needsExtraBr && <br />}
      </React.Fragment>
    );
  });
};
